export default function (method) {
    return `/services/${method.parent.fullName.slice(1)}/${method.name}`;
}
